import Link from 'next/link';
import { AuthErrorCode } from '@/domains/auth/api/responseHelpers/error';
import globalVariables from '@/domains/shared/data/globalVariables';

export const loginErrorMessages: Partial<
  Record<AuthErrorCode, string | React.ReactNode>
> = {
  'AUTH/INVALID-EMAIL-OR-PASSWORD':
    'Incorrect email or password. Please try again.',
  'AUTH/ACCOUNT-CLOSED': (
    <>
      Your account is closed. If you wish to reopen your account, please contact
      us. You can call us on{' '}
      <Link
        className="text-blue-100 underline hover:cursor-pointer hover:text-blue-140 focus-visible:rounded-4 focus-visible:outline"
        href={`tel:${globalVariables.pensionbeeContactPhoneNumber}`}
      >
        {globalVariables.pensionbeeContactPhoneNumber}
      </Link>{' '}
      or email us at{' '}
      <Link
        className="text-blue-100 underline hover:cursor-pointer hover:text-blue-140 focus-visible:rounded-4 focus-visible:outline"
        href={`mailto:${globalVariables.pensionbeeContactEmailAddress}`}
      >
        {globalVariables.pensionbeeContactEmailAddress}
      </Link>
      .
    </>
  ),
  'AUTH/TOO-MANY-ATTEMPTS':
    'Too many unsuccessful login attempts. Please try again in 30 minutes.',
  'AUTH/FORBIDDEN':
    'We cannot log you in right now. If the problem continues, please contact your BeeKeeper.',
  'AUTH/UNKNOWN-ERROR':
    'We cannot log you in right now. If the problem continues, please contact your BeeKeeper.',
} as const;

export const LOGIN_ERROR_QUERY_KEY = 'error';

const loginErrorQueryValues = {
  'invalid-credentials': 'AUTH/INVALID-EMAIL-OR-PASSWORD',
} as const satisfies Record<string, AuthErrorCode>;

type LoginErrorQueryValue = keyof typeof loginErrorQueryValues;

export const getLoginErrorMessageFromQuery = (
  queryValue: string | string[] | undefined,
) => {
  if (typeof queryValue !== 'string') return undefined;
  const errorCode = loginErrorQueryValues[queryValue as LoginErrorQueryValue];
  return errorCode ? loginErrorMessages[errorCode] : undefined;
};
